import type { AxiosInstance, AxiosStatic } from "axios";
import axios from "axios";
import { AuthenticationService } from "../../legacy/services/authentication-service/authentication.service";
import type { IAuthenticationService } from "../../legacy/services/authentication-service/authentication.service.interface";
import type { IApiClientFactory } from "./api-client.factory.interface";
import { AxiosInterceptorAuthorization } from "./interceptors/axios-interceptor-authorization/axios-interceptor-authorization";
import { invalidateProductCacheOnCitizenDataMutation } from "./interceptors/product-cache-invalidation/product-cache-invalidation.interceptor";
import type { IApiClientConfig } from "./types/api-client-config.interface";

export class ApiClientFactory implements IApiClientFactory {
  constructor(
    private readonly _axiosStatic: AxiosStatic = axios,
    private readonly _authenticationService?: IAuthenticationService
  ) {}

  public createClient(config: IApiClientConfig): AxiosInstance {
    const client = this._axiosStatic.create({
      baseURL: config.baseURL,
      timeout: config.timeout ?? 30000,
      withCredentials: config.withCredentials ?? true,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
    });

    this._setupInterceptors(client);

    return client;
  }

  private _setupInterceptors(client: AxiosInstance): void {
    const authService = this._authenticationService || new AuthenticationService();
    const interceptor = new AxiosInterceptorAuthorization(authService);

    const onFulfilled = interceptor.onFulfilled.bind(interceptor);
    const onRejected = interceptor.onRejected.bind(interceptor);

    client.interceptors.response.use(onFulfilled, onRejected);
    client.interceptors.response.use(invalidateProductCacheOnCitizenDataMutation);
  }
}
